export const PAIN_ASSESSMENT_SCALE = {
  masterTableName: "MC_PAIN_ASSMENT_SCORE",
  tableName: "MC_PAIN_ASSMENT_SCORE_DET",
  columnName: "PAS_ID",
  columnValue: 0,
  title: "painAssessmentScale.painAssessmentScale-detail",
  rows: [
    { title: "ID", value: "ID" },
    { title: "PAS_ID", value: "PAS_ID" },
    { title: "CTIME", value: "CTIME", type: "date" },
    { title: "CUSER", value: "CUSER" },
    { title: "PROCESS_TIME", value: "PROCESS_TIME", type: "date" },
    { title: "PAIN_SCALE", value: "PAIN_SCALE" },
    { title: "PLACE_OF_PAIN", value: "PLACE_OF_PAIN" },
    { title: "TYPE_AND_QUALITIES", value: "TYPE_AND_QUALITIES" },
    { title: "ACCOMPANYING_SYMPTOMS", value: "ACCOMPANYING_SYMPTOMS" },
    { title: "BEGIN_TIME", value: "BEGIN_TIME", type: "date" },
    { title: "TIME", value: "TIME" },
    { title: "FREQUENCY", value: "FREQUENCY" },
    { title: "DAILY_LIFE_EFFECTS", value: "DAILY_LIFE_EFFECTS" },
    { title: "SPREAD_OF_PAIN", value: "SPREAD_OF_PAIN" },
    { title: "SIDE_EFFECTS", value: "SIDE_EFFECTS" },
    { title: "NIPS_FACE_EXPRESSION", value: "NIPS_FACE_EXPRESSION" },
    { title: "NIPS_CRY", value: "NIPS_CRY" },
    { title: "NIPS_RESPIRATORY_FORM", value: "NIPS_RESPIRATORY_FORM" },
    { title: "NIPS_ARMS", value: "NIPS_ARMS" },
    { title: "NIPS_LEGS", value: "NIPS_LEGS" },
    { title: "NIPS_WAKEFULLNESS", value: "NIPS_WAKEFULLNESS" },
    { title: "FLACC_FACE_EXPRESSION", value: "FLACC_FACE_EXPRESSION" },
    { title: "FLACC_LEGS", value: "FLACC_LEGS" },
    { title: "FLACC_ACTIVITE", value: "FLACC_ACTIVITE" },
    { title: "FLACC_CRY", value: "FLACC_CRY" },
    { title: "FLACC_CONSOLATION", value: "FLACC_CONSOLATION" },
    { title: "DAS_FACE_EXPRESSION", value: "DAS_FACE_EXPRESSION" },
    { title: "DAS_UPPER_EXTREMITY_MOV", value: "DAS_UPPER_EXTREMITY_MOV" },
    { title: "DAS_ADAPTATION_VEN", value: "DAS_ADAPTATION_VEN" },
    { title: "NIPS_SCALE_SCORE", value: "NIPS_SCALE_SCORE" },
    { title: "FLACC_SCALE_SCORE", value: "FLACC_SCALE_SCORE" },
    { title: "WONG_BAKER_SCALE_SCORE", value: "WONG_BAKER_SCALE_SCORE" },
    { title: "VAS_SCALE_SCORE", value: "VAS_SCALE_SCORE" },
    { title: "DAS_SCALE_SCORE", value: "DAS_SCALE_SCORE" },
    { title: "INCREASING_FACTORS", value: "INCREASING_FACTORS" },
    {
      title: "INCREASING_FACTORS_EXPLANATION",
      value: "INCREASING_FACTORS_EXPLANATION",
    },
    { title: "REDUCING_FACTORS", value: "REDUCING_FACTORS" },
    {
      title: "REDUCING_FACTORS_EXPLANATION",
      value: "REDUCING_FACTORS_EXPLANATION",
    },
    { title: "PIPP_GESTATIONAL_AGE", value: "PIPP_GESTATIONAL_AGE" },
    { title: "PIPP_BEHAVIORAL_STATE", value: "PIPP_BEHAVIORAL_STATE" },
    { title: "PIPP_MAX_HEART_RATE", value: "PIPP_MAX_HEART_RATE" },
    {
      title: "PIPP_MIN_OXYGEN_SATURATION",
      value: "PIPP_MIN_OXYGEN_SATURATION",
    },
    { title: "PIPP_BROW_BULGE", value: "PIPP_BROW_BULGE" },
    { title: "PIPP_EYE_SQUEEZE", value: "PIPP_EYE_SQUEEZE" },
    { title: "PIPP_NASOLABIAL_FURROW", value: "PIPP_NASOLABIAL_FURROW" },
    { title: "PIPP_SCALE_SCORE", value: "PIPP_SCALE_SCORE" },
    { title: "EVALUATION_REASON", value: "EVALUATION_REASON" },
    { title: "SIDE", value: "SIDE" },
    { title: "PAIN_EFFECT", value: "PAIN_EFFECT" },
    { title: "PAIN_REDUCTION_TARGET", value: "PAIN_REDUCTION_TARGET" },
    { title: "TARGET_EXPLANATION", value: "TARGET_EXPLANATION" },
    { title: "PLACE_PAIN_EXPLANATION", value: "PLACE_PAIN_EXPLANATION" },
    {
      title: "TYPE_QUALITIES_EXPLANATION",
      value: "TYPE_QUALITIES_EXPLANATION",
    },
  ],
  fields: [
    {
      field: "PROCESS_TIME",
      headerName: "process-time",
      flex: 1,
      type: "Date",
    },
    { field: "PAIN_SCALE", headerName: "Ağrı Skalası", flex: 1 },
    { field: "place_of_pain", headerName: "Ağrının Yeri", flex: 1 },
    {
      field: "type_and_qualities",
      headerName: "Türü ve Nitelikleri",
      flex: 1,
    },
    {
      field: "accompanying_symptoms",
      headerName: "Eşlik Eden Semptomlar",
      flex: 1,
    },
    { field: "frequency", headerName: "Sıklığı", flex: 1 },
    {
      field: "total_score",
      headerName: "Toplam Skor",
      flex: 1,
      computed: true,
      calculate: (row: any) => {
        const nips = Number(row.nips_scale_score) || 0;
        const flacc = Number(row.flacc_scale_score) || 0;
        const wong = Number(row.wong_baker_scale_score) || 0;
        const vas = Number(row.vas_scale_score) || 0;
        const das = Number(row.das_scale_score) || 0;
        const pipp = Number(row.pipp_scale_score) || 0;
        return nips + flacc + wong + vas + das + pipp;
      },
    },
  ],
  mcpConfig: {
    PAIN_SCALE: {
      mcpId: 140,
      field: "PAIN_SCALE",
      scoreField: "PAIN_SCALE_XVALUE",
    },
    PLACE_OF_PAIN: {
      mcpId: 141,
      field: "PLACE_OF_PAIN",
      scoreField: "PLACE_OF_PAIN_XVALUE",
    },
    FREQUENCY: {
      mcpId: 142,
      field: "FREQUENCY",
      scoreField: "FREQUENCY_XVALUE",
    },
    TYPE_AND_QUALITIES: {
      mcpId: 143,
      field: "TYPE_AND_QUALITIES",
      scoreField: "TYPE_AND_QUALITIES_XVALUE",
    },
    ACCOMPANYING_SYMPTOMS: {
      mcpId: 144,
      field: "ACCOMPANYING_SYMPTOMS",
      scoreField: "ACCOMPANYING_SYMPTOMS_XVALUE",
    },
    DAILY_LIFE_EFFECTS: {
      mcpId: 145,
      field: "DAILY_LIFE_EFFECTS",
      scoreField: "DAILY_LIFE_EFFECTS_XVALUE",
    },
    INCREASING_FACTORS: {
      mcpId: 161,
      field: "INCREASING_FACTORS",
      scoreField: "INCREASING_FACTORS_XVALUE",
    },
    REDUCING_FACTORS: {
      mcpId: 162,
      field: "REDUCING_FACTORS",
      scoreField: "REDUCING_FACTORS_XVALUE",
    },
    NIPS_FACE_EXPRESSION: {
      mcpId: 146,
      field: "NIPS_FACE_EXPRESSION",
      scoreField: "NIPS_FACE_EXPRESSION_XVALUE",
    },
    NIPS_CRY: {
      mcpId: 147,
      field: "NIPS_CRY",
      scoreField: "NIPS_CRY_XVALUE",
    },
    NIPS_RESPIRATORY_FORM: {
      mcpId: 148,
      field: "NIPS_RESPIRATORY_FORM",
      scoreField: "NIPS_RESPIRATORY_FORM_XVALUE",
    },
    NIPS_ARMS: {
      mcpId: 149,
      field: "NIPS_ARMS",
      scoreField: "NIPS_ARMS_XVALUE",
    },
    NIPS_LEGS: {
      mcpId: 150,
      field: "NIPS_LEGS",
      scoreField: "NIPS_LEGS_XVALUE",
    },
    NIPS_WAKEFULLNESS: {
      mcpId: 151,
      field: "NIPS_WAKEFULLNESS",
      scoreField: "NIPS_WAKEFULLNESS_XVALUE",
    },
    FLACC_FACE_EXPRESSION: {
      mcpId: 152,
      field: "FLACC_FACE_EXPRESSION",
      scoreField: "FLACC_FACE_EXPRESSION_XVALUE",
    },
    FLACC_LEGS: {
      mcpId: 153,
      field: "FLACC_LEGS",
      scoreField: "FLACC_LEGS_XVALUE",
    },
    FLACC_ACTIVITE: {
      mcpId: 154,
      field: "FLACC_ACTIVITE",
      scoreField: "FLACC_ACTIVITE_XVALUE",
    },
    FLACC_CRY: {
      mcpId: 155,
      field: "FLACC_CRY",
      scoreField: "FLACC_CRY_XVALUE",
    },
    FLACC_CONSOLATION: {
      mcpId: 156,
      field: "FLACC_CONSOLATION",
      scoreField: "FLACC_CONSOLATION_XVALUE",
    },
    DAS_FACE_EXPRESSION: {
      mcpId: 157,
      field: "DAS_FACE_EXPRESSION",
      scoreField: "DAS_FACE_EXPRESSION_XVALUE",
    },
    DAS_UPPER_EXTREMITY_MOV: {
      mcpId: 158,
      field: "DAS_UPPER_EXTREMITY_MOV",
      scoreField: "DAS_UPPER_EXTREMITY_MOV_XVALUE",
    },
    DAS_ADAPTATION_VEN: {
      mcpId: 159,
      field: "DAS_ADAPTATION_VEN",
      scoreField: "DAS_ADAPTATION_VEN_XVALUE",
    },
    PIPP_GESTATIONAL_AGE: {
      mcpId: 796,
      field: "PIPP_GESTATIONAL_AGE",
      scoreField: "PIPP_GESTATIONAL_AGE_XVALUE",
    },
    PIPP_BEHAVIORAL_STATE: {
      mcpId: 797,
      field: "PIPP_BEHAVIORAL_STATE",
      scoreField: "PIPP_BEHAVIORAL_STATE_XVALUE",
    },
    PIPP_MAX_HEART_RATE: {
      mcpId: 798,
      field: "PIPP_MAX_HEART_RATE",
      scoreField: "PIPP_MAX_HEART_RATE_XVALUE",
    },
    PIPP_MIN_OXYGEN_SATURATION: {
      mcpId: 799,
      field: "PIPP_MIN_OXYGEN_SATURATION",
      scoreField: "PIPP_MIN_OXYGEN_SATURATION_XVALUE",
    },
    PIPP_BROW_BULGE: {
      mcpId: 800,
      field: "PIPP_BROW_BULGE",
      scoreField: "PIPP_BROW_BULGE_XVALUE",
    },
    PIPP_EYE_SQUEEZE: {
      mcpId: 801,
      field: "PIPP_EYE_SQUEEZE",
      scoreField: "PIPP_EYE_SQUEEZE_XVALUE",
    },
    PIPP_NASOLABIAL_FURROW: {
      mcpId: 802,
      field: "PIPP_NASOLABIAL_FURROW",
      scoreField: "PIPP_NASOLABIAL_FURROW_XVALUE",
    },
    SIDE: { mcpId: 900, field: "SIDE", scoreField: "SIDE_XVALUE" },
    EVALUATION_REASON: {
      mcpId: 901,
      field: "EVALUATION_REASON",
      scoreField: "EVALUATION_REASON_XVALUE",
    },
    PAIN_EFFECT: {
      mcpId: 954,
      field: "PAIN_EFFECT",
      scoreField: "PAIN_EFFECT_XVALUE",
    },
    PAIN_REDUCTION_TARGET: {
      mcpId: 955,
      field: "PAIN_REDUCTION_TARGET",
      scoreField: "PAIN_REDUCTION_TARGET_XVALUE",
    },
    //NON_MEDICAL_APP: { mcpId: 956, field: "NON_MEDICAL_APP", scoreField: "NON_MEDICAL_APP_XVALUE" },
    //ACTIVITY_CONTROL: { mcpId: 958, field: "ACTIVITY_CONTROL", scoreField: "ACTIVITY_CONTROL_XVALUE" },
  } as Record<string, { mcpId: number; field: string; scoreField: string }>,
  formData: {
    PAS_ID: "",
    PROCESS_TIME: new Date(),
    CTIME: new Date(),
    CUSER: "",
    PAIN_SCALE: "",
    PLACE_OF_PAIN: "",
    TYPE_AND_QUALITIES: "",
    ACCOMPANYING_SYMPTOMS: "",
    BEGIN_TIME: new Date(),
    TIME: "",
    FREQUENCY: "",
    DAILY_LIFE_EFFECTS: "",
    SPREAD_OF_PAIN: "",
    SIDE_EFFECTS: "",
    NIPS_FACE_EXPRESSION: "",
    NIPS_CRY: "",
    NIPS_RESPIRATORY_FORM: "",
    NIPS_ARMS: "",
    NIPS_LEGS: "",
    NIPS_WAKEFULLNESS: "",
    FLACC_FACE_EXPRESSION: "",
    FLACC_LEGS: "",
    FLACC_ACTIVITE: "",
    FLACC_CRY: "",
    FLACC_CONSOLATION: "",
    DAS_FACE_EXPRESSION: "",
    DAS_UPPER_EXTREMITY_MOV: "",
    DAS_ADAPTATION_VEN: "",
    NIPS_SCALE_SCORE: "",
    FLACC_SCALE_SCORE: "",
    WONG_BAKER_SCALE_SCORE: "",
    VAS_SCALE_SCORE: "",
    DAS_SCALE_SCORE: "",
    INCREASING_FACTORS: "",
    INCREASING_FACTORS_EXPLANATION: "",
    REDUCING_FACTORS: "",
    REDUCING_FACTORS_EXPLANATION: "",
    PIPP_GESTATIONAL_AGE: "",
    PIPP_BEHAVIORAL_STATE: "",
    PIPP_BROW_BULGE: "",
    PIPP_MAX_HEART_RATE: "",
    PIPP_MIN_OXYGEN_SATURATION: "",
    PIPP_EYE_SQUEEZE: "",
    PIPP_NASOLABIAL_FURROW: "",
    PIPP_SCALE_SCORE: "",
    EVALUATION_REASON: "",
    SIDE: "",
    PAIN_EFFECT: "",
    PAIN_REDUCTION_TARGET: "",
    TARGET_EXPLANATION: "",
    PLACE_PAIN_EXPLANATION: "",
    TYPE_QUALITIES_EXPLANATION: "",
    //NON_MEDICAL_APP: "",
    // ACTIVITY_CONTROL: ""
  },
};
